// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__17Cto","content":"RecentSearches_content__3igaS"};